module.exports = __webpack_public_path__ + "media/Face_to_Sticker.7a9ce938.webm";